export default "__VITE_ASSET__BGZJm1J0__"